// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/sparkle.js';

import { paths } from '../generated/sparkle';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('sparkle', Original, paths);
